const client_id = 'Inavista.js';
const sso_redirect_url = 'https://stage.auth.inavista.com/auth/callback';
const scope = 'openid';
const state = 'cC7BRH8TDiRbOIaM';
const authAppUrl = 'https://stage.auth.inavista.com';

export const environment = {
    production: false,
    stage: true,
    development: false,
    testDevelopment: false,
    resetPasswordURL: `${authAppUrl}/setup-new-password`,
    appUrl: 'https://stage.rims.inavista.com/auth',
    appApiUrl: 'https://app-api-auth-stg-eastus-01.azurewebsites.net/api/',
    apiUrl: 'https://stage.api.auth.inavista.com/api/',
    // redirectUrl: 'https://sso1beta.snapon.com/connect/authorize?client_id=MobileAppStaging2.js&redirect_uri=https://stage2-rims.inavista.com/auth&response_type=id_token%20token&scope=openid%20profile%20Roles&state=16814521988200.r1zay15nyk8&nonce=16814521988200.v9t82wc9jjh',
    syncfusionLicenseKey: 'Ngo9BigBOggjHTQxAR8/V1NAaF1cXmhIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEFjW31WcHNXQ2RVV0xwVw==',
    ssoAuthorizationUrl: `https://logintest.snapon.com/connect/authorize?`+
        `response_type=code`+
        `&client_id=${client_id}`+
        `&redirect_uri=${sso_redirect_url}`+
        `&scope=${scope}`+
        `&state=${state}`,
};